import { useState, useEffect } from 'react';
import { getPaidFilters } from '../api/paidFilters';

export const flattenPaidFilters = (filters) => {
  if (!Array.isArray(filters)) return [];

  const result = [];

  filters.forEach((f) => {
    if (f.items?.length > 0) {
      f.items.forEach((child) => {
        result.push({
          id: child.id,
          name: child.name,
          description: child.description,
          parentName: f.name,
        });
      });
    } else {
      result.push({
        id: f.id,
        name: f.name,
        description: f.description,
        parentName: null,
      });
    }
  });

  return result;
};

export const usePaidFilters = () => {
  const [paidFilters, setPaidFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const data = await getPaidFilters();
        setPaidFilters(flattenPaidFilters(data || []));
      } catch (err) {
        setError(err.message || 'Ошибка при загрузке');
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, []);

  return {
    paidFilters,
    isLoading,
    error,
  };
};
